/*eslint-disable array-callback-return */
/*eslint-disable linebreak-style */
/*eslint-disable eqeqeq */
/*eslint-disable no-redeclare */
/*eslint-disable no-unused-vars */
import React, { useEffect, useState } from 'react';
import { useSelector, useDispatch } from 'react-redux';
import { Link, Navigate, useNavigate, useLocation } from 'react-router-dom';
import {
  Container,
  Row,
  Col,
  Button,
  Form,
  Tab,
  Tabs,
  Nav,
  Pagination,
} from 'react-bootstrap';
import { ToastContainer } from 'react-toastify';
import { MDBCol, MDBIcon } from 'mdbreact';

import { IDCardDownloadSVG, EmailSVG } from '../../img/IDCardSVG';
import { CoveragesSVG } from '../../img/tab_icons/CoveragesSVG';
import { ClaimsSVG } from '../../img/tab_icons/ClaimsSVG';
import { AccountsSVG } from '../../img/tab_icons/AccountsSVG';
import { IDCardSVG } from '../../img/tab_icons/IDCardSVG';
import { DocumentsSVG } from '../../img/tab_icons/DocumentsSVG';
import { ProfileSVG } from '../../img/tab_icons/ProfileSVG';
import { AccumulatorSVG } from '../../img/tab_icons/AccumulatorSVG';

import './viewmember.scss';
import MyIDCards from './myidcards/myidcards';
import Coverage from './coverage/coverage';
import MemberSkeleton from './memberSkeleton';
import MyIDCardSkeleton from './myidcards/MyIDCardSkeleton';
import '../commonstyle.scss';
import Claims from './claims/index';
import Accounts from './accounts';
import MasterPermissions from '../../api/MasterPermissions';
import Header from '../../components/common/Header/Header';
import GenericButton from '../../components/common/button/GenericButton/GenericButton';
import CustomClientError from '../../errorhandling/CustomClientError';
import Accumulators from './accumulators';
import { resetNetworkList } from 'src/redux/admin/accumulatorSlice';

import {
  HttpErrorCodes,
  HttpSuccessCodes,
} from '../../errorhandling/HttpErrorCodes';
import APIEndpoints from '../../api/APIEndpoints';
import { axiosInstance } from '../../../api/axios';
import CookiesService from '../../shared/CookiesService';
import {
  setSelectedMember,
  setMemberDetails,
  setMemberList,
} from '../../../redux/admin/memberModule';
import {
  findOutDefaultRangeBasedOnHistory,
  findEffectiveDateInPlanYear,
  makeDatesArrayAsPerNeed,
} from '../../utils/dates';

import { Label } from 'semantic-ui-react';
import { resetSearchParams } from 'src/redux/admin/claimsSlice';

import ViewAllDocuments from '../../../Admin/components/uploaddocument/ViewAllDocuments';
import moment from 'moment';

import Profile from './Profile';
import store from 'src/redux/store';

const cacheBuster = (url) => `${url}?cb=${Date.now()}`;
const MemberInfo = [];
const ViewMember = (props) => {
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const location = useLocation();
  console.log(location.state);
  const { selectedMember, filterParams, memberList } = useSelector(
    (state) => state.memberModule,
  );
  const { userData = {} } = useSelector((state) => state.user || {});
  const [dataFetching, setDataFetching] = useState(false);
  const [isAPIFailed, setIsAPIFailed] = useState(false);
  const [isNotFound, setIsNotFound] = useState(false);
  const [currentUser, setCurrentUser] = useState(selectedMember?.ID);
  const [memberType, setMemberType] = useState(selectedMember?.mType);
  const [memberInfo, setMemberInfo] = useState([]);
  const [dependentList, setDependentList] = useState([]);
  const [memberSummary, setMemberSummary] = useState();
  const [coverageFor, setCoverageFor] = useState();
  const [activeCoverage, setActiveCoverage] = useState();
  const [selectedUser, setSelectedUser] = useState(undefined);
  //extended coverage
  const [planDetails, setPlanDetails] = useState(null);
  const [coverageData, setCoverageData] = useState(null);
  const [coverageProducts, setCoverageProducts] = useState(null);
  const [isFamilySelected, setisFamilySelected] = useState(false);

  const [defaultData, setDefaultData] = useState(null);

  const setTabFlag = false;

  const [value, setValue] = React.useState();
  const [selectedTab, setSelectedTab] = useState('coverages');
  const [isAccountsVisible, setisAccountsVisible] = useState(false);
  const [isBenefitAccumsVisible, setIsBenefitAccumsVisible] = useState(true);
  const [isDocumentVisible, setIsDocumentVisible] = useState(true);
  const [showPermissionError, setShowPermissionMsg] = useState(false);
  const { Features_Setting } =
    useSelector((state) => state.app?.appConfigs) || {};
  const FEATURES = Features_Setting;

  //const { searchParams: {claimCategory}} = useSelector(({claims})=> claims);
  const userTypeCheck = store.getState().user?.userData?.UserType;

  useEffect(() => {
    setisAccountsVisible(false);
    const feature = FEATURES?.find(
      (feature) => feature.Name === 'spendingAccount',
    );
    if (feature && feature.Status === false) {
      setisAccountsVisible(true);
    }
    const featureAccums = FEATURES?.find(
      (feature) => feature.Name === 'BenefitAccumulator',
    );
    if (featureAccums.Status === true) {
      setIsBenefitAccumsVisible(true);
    } else if (featureAccums.Status === false) {
      setIsBenefitAccumsVisible(false);
    }
    const featureFlag = FEATURES?.find(
      (feature) => feature.Name === 'SendDocument',
    );
    featureFlag && featureFlag.Status === true
      ? setIsDocumentVisible(true)
      : setIsDocumentVisible(false);

    if (memberList?.length > 0) {
      const selectData = memberList.filter(
        (ele) => ele.OID === selectedMember?.ID,
      );
      if (selectData?.length > 0) {
        setSelectedUser({
          label: selectData[0]?.name,
          value: `${selectData[0]?.OID}_${selectData[0]?.name}`,
        });
      }
    }
  }, [memberList]);

  const selectTab = () => {
    const source = new URLSearchParams(location.search).get('source');
    if (source != null && source != undefined) {
      const elem = document.querySelector(
        '#uncontrolled-tab-example-tab-' + source,
      );
      //elem.addEventListener('click', e => {});
      elem.click();
      elem.dispatchEvent(new Event('click'));
      window.scrollTo(0, 0);
    } else {
      const tab = sessionStorage.getItem('user-tab');
      if (tab != null) {
        const elem = document.querySelector(
          '#uncontrolled-tab-example-tab-' + tab,
        );
        //elem.addEventListener('click', e => {});
        elem.click();
        elem.dispatchEvent(new Event('click'));
        window.scrollTo(0, 0);
      }
    }
  };

  const coverageChangeHandler = (e) => {
    setDataFetching(true);
    setIsAPIFailed(false);
    setSelectedUser(e);
    let selectedIndex;
    if (e.label.includes('Family (')) {
      selectedIndex = '0';
      setisFamilySelected(true);
      if (selectedTab == 'acsummary') {
        makeCoverageActive();
      }
    } else {
      selectedIndex = coverageFor?.findIndex(
        (coverage) => coverage?.value === e.value.split('_')[0],
      );
      if (selectedTab == 'acsummary' && selectedIndex != 0) {
        makeCoverageActive();
      }
      setisFamilySelected(false);
    }
    setActiveCoverage(coverageFor[selectedIndex]);
    setCurrentUser(coverageFor[selectedIndex].value.split('_')[0]);
    const item = memberInfo.find(
      (opt) => opt.OID === coverageFor[selectedIndex].value.split('_')[0],
    );
    setMemberType(item.coverageType);
    dispatch(
      setSelectedMember({
        ID: coverageFor[selectedIndex].value.split('_')[0],
        mType: item.coverageType,
        label: e.label,
      }),
    );
    dispatch(resetSearchParams());
    dispatch(resetNetworkList());
    setDataFetching(false);
  };

  const getMemberDetails = async () => {
    setDataFetching(true);
    setIsAPIFailed(false);
    let response;
    try {
      const response = await axiosInstance.get(
        cacheBuster(
          APIEndpoints.getMemberSummaryResource() +
            'membertype/' +
            memberType +
            '/oid/' +
            currentUser,
        ),
      );

      const memberSummaryDataResp = response.data;
      const memberSummary = memberSummaryDataResp?.Response?.Member;
      if (response.status === HttpSuccessCodes.HTTP_SUCCESS_CODE_200) {
        //Setting Member Summary Response
        CookiesService.set(
          'MemberSummary',
          JSON.stringify(memberSummaryDataResp),
        );
        setMemberSummary(memberSummaryDataResp);
        dispatch(setMemberDetails(memberSummaryDataResp?.Response));
        setDependentList(memberSummary?.DependentsInfo);

        const MemberList = [];
        if (memberSummary?.DependentsInfo?.length == 0) {
          MemberList.push({
            name:
              memberSummary?.FirstName + ' (' + memberSummary?.LastName + ')',
            fullname: memberSummary?.FirstName + ' ' + memberSummary?.LastName,
            count: 0,
            coverageType:
              memberSummary?.LoggedInMemberType == 'Employee'
                ? 'Employee'
                : 'Dependent',
            OID: memberSummary?.OID,
          });
        } else {
          console.log('With Dependents');

          MemberList.push({
            name:
              memberSummary?.FirstName + ' (' + memberSummary?.LastName + ')',
            fullname: memberSummary?.FirstName + ' ' + memberSummary?.LastName,
            FirstName: memberSummary?.FirstName,
            count: 1,
            coverageType: 'Employee',
            OID: memberSummary?.OID,
          });
          let dependent;

          for (
            let iIndex = 0;
            iIndex < memberSummary.DependentsInfo?.length;
            iIndex++
          ) {
            dependent = memberSummary?.DependentsInfo[iIndex];
            MemberList.push({
              name:
                dependent?.FirstName +
                ' (' +
                dependent?.RelationshipToMember +
                ')',
              fullname: dependent?.FirstName + ' ' + dependent?.LastName,
              FirstName: memberSummary?.FirstName,
              count: iIndex + 1,
              coverageType: 'Dependent',
              OID: dependent?.OID,
            });
          }
        }
        CookiesService.set('MemberInfo', JSON.stringify(MemberList));
        //saving Member Information into Session objects

        setMemberInfo(MemberList);
        dispatch(setMemberList(MemberList));

        const memberOptions = MemberList?.map((m) => {
          return {
            label: m.name,
            value: m.OID,
          };
        });
        setCoverageFor(memberOptions);
        //setActiveCoverage( coverageFor[ 0 ] )
      }
    } catch (error) {
      console.log(error);
      setDataFetching(false);
      setIsAPIFailed(true);
    }
  };

  const Coverage_Year_Range =
    useSelector(
      (state) => state.app.appConfigs.Common_Setting.Coverage_Year_Range,
    ) || 5;

  const fetchCoverageSummary = async (currentUser, memberType) => {
    setDataFetching(true);
    const currentDate = moment().format('YYYY-MM-DD');
    try {
      const responseHistoryAPI = await axiosInstance.get(
        APIEndpoints.getMemberExtCoverageSummaryResource() +
          memberType +
          '/oid/' +
          currentUser,
      );
      if (
        responseHistoryAPI &&
        responseHistoryAPI?.data.Response.EligibilityCoverage.length > 0
      ) {
        const memberHistoryData =
          responseHistoryAPI?.data.Response.EligibilityCoverage;
        const defaultSeleactedYear =
          findOutDefaultRangeBasedOnHistory(memberHistoryData);
        console.log('===============================');
        console.log(defaultSeleactedYear);

        if (
          defaultSeleactedYear &&
          defaultSeleactedYear.MemberCoverage.length > 0
        ) {
          const firstItemSelected = defaultSeleactedYear.MemberCoverage[0];
          const currentActiveCoverageType = firstItemSelected.Product;
          let defaultDateFilters = null;
          let memberYearData = null;
          let allPlanYear = null;

          //if ( moment( currentDate ).isSameOrAfter( defaultSeleactedYear.EffectiveDate, 'year' ) ) {
          const responseYearAPI = await axiosInstance.get(
            APIEndpoints.getPlanYearPeriod() +
              '/EmployeeType/' +
              memberType +
              '/oid/' +
              currentUser +
              '/Product/' +
              currentActiveCoverageType +
              '/Year/' +
              Coverage_Year_Range,
          );
          allPlanYear = responseYearAPI?.data.Response.PlanYearPeriod;
          memberYearData = responseYearAPI?.data.Response.PlanYearPeriod;
          console.log('++++++++++++++++++++++');
          memberYearData = makeDatesArrayAsPerNeed(memberYearData);

          //if ( moment( defaultSeleactedYear.EffectiveDate ).format( 'YYYY-MM-DD' ) <= currentDate ) {
          if (
            moment(currentDate).isSameOrAfter(
              defaultSeleactedYear.EffectiveDate,
              'year',
            )
          ) {
            defaultDateFilters = findEffectiveDateInPlanYear(
              memberYearData,
              currentDate,
            );
          }
          console.log(defaultDateFilters);

          if (defaultDateFilters === null || defaultDateFilters === undefined) {
            const tempYear = moment(defaultSeleactedYear.EffectiveDate).year();
            defaultDateFilters = {
              PlanYearDescription: `${tempYear}-01-01 - ${tempYear}-12-31`,
              PlanYear: tempYear,
              fromDate: `${tempYear}-01-01`,
              toDate: `${tempYear}-12-31`,
            };
            memberYearData = [
              {
                PlanYearDescription: `${tempYear}-01-01 - ${tempYear}-12-31`,
                PlanYear: tempYear,
                fromDate: `${tempYear}-01-01`,
                toDate: `${tempYear}-12-31`,
              },
            ];
            allPlanYear.push({
              PlanYearValue: 'null',
              PlanYearDescription: `${tempYear}-01-01 - ${tempYear}-12-31`,
              PlanYear: tempYear,
              fromDate: `${tempYear}-01-01`,
              toDate: `${tempYear}-12-31`,
            });
          }

          if (defaultDateFilters) {
            const defaultFromDate = defaultDateFilters.fromDate;
            const defaultToDate = defaultDateFilters.toDate;

            const responseExtCoverage = await axiosInstance.get(
              APIEndpoints.getMemberCoveragePlan() +
                memberType +
                '/oid/' +
                currentUser +
                '/planstartdate/' +
                defaultFromDate +
                '/planenddate/' +
                defaultToDate,
            );
            const memberExtCoverageSummary =
              responseExtCoverage?.data.Response.EligibilityCoverage;
            const memberExtCoveragePlanDetails =
              responseExtCoverage?.data.Response.EligibilityCoverage[0];
            const memberExtCoveragedata =
              responseExtCoverage?.data.Response.EligibilityCoverage[0]
                .MemberCoverage;
            setCoverageData(memberExtCoverageSummary);
            setPlanDetails(memberExtCoveragePlanDetails);
            setCoverageProducts(memberExtCoveragedata);
            setIsAPIFailed(false);
            setIsNotFound(false);
            setDataFetching(false);
          }

          allPlanYear = makeDatesArrayAsPerNeed(allPlanYear);
          setDefaultData({
            coverage: firstItemSelected,
            allPlanYear: allPlanYear,
            dateRange: defaultDateFilters,
            yearOptions: memberYearData,
          });
        }
      } else {
        throw new Error('404 history not found');
      }
    } catch (err) {
      setDataFetching(false);
      if (err.toString().includes('404')) {
        setIsNotFound(true);
      }
      setIsAPIFailed(true);
    }
  };

  const displayErrorMsg = () => {
    setShowPermissionMsg(true);
  };

  const tabClickHandler = (e) => {
    setSelectedTab(e);
    dispatch(resetNetworkList());
    if (e != 'claims') {
      dispatch(resetSearchParams());
    }
  };

  useEffect(() => {
    selectTab();
    if (selectedTab != 'claims') {
      getMemberDetails();
    }
  }, []);
  useEffect(() => {
    if (selectedTab != 'claims') {
      fetchCoverageSummary(currentUser, memberType);
    }
  }, [currentUser]);

  const makeCoverageActive = (tab = 'coverages') => {
    const elem = document.querySelector('#uncontrolled-tab-example-tab-' + tab);
    elem.click();
    elem.dispatchEvent(new Event('click'));
    window.scrollTo(0, 0);
  };

  return (
    <div>
      <div id="id-card" className="admin-coverage-details">
        <Header
          linkTo={'/admin/member-management'}
          preserveData={{ ...location.state }}
          header="Plan Coverage Details"
          dropdownLabel="Show Details For :"
          selectedUser={selectedUser}
          coverageChangeHandler={coverageChangeHandler}
        />

        <Row>
          <Col>
            <Tabs
              defaultActiveKey="coverages"
              id="uncontrolled-tab-example"
              onSelect={tabClickHandler}
              className="vmTabs admin-member-nav-tabs"
            >
              {userTypeCheck != 'Provider' &&
                MasterPermissions.CheckPermission('View Coverage Details') &&
                (MasterPermissions.CheckPermission('Medical Coverage') ||
                  MasterPermissions.CheckPermission('Dental Coverage') ||
                  MasterPermissions.CheckPermission('Vision Coverage') ||
                  MasterPermissions.CheckPermission('Prescription Coverage') ||
                  MasterPermissions.CheckPermission(
                    'Long Term Disability Coverage',
                  ) ||
                  MasterPermissions.CheckPermission(
                    'Short Term Disability Coverage',
                  ) ||
                  MasterPermissions.CheckPermission(
                    'Supplemental Coverage',
                  )) && (
                  <Tab
                    eventKey="coverages"
                    title={
                      <span>
                        <CoveragesSVG
                          className="svg-icons"
                          parentClassName="svg-class"
                        />
                        Coverages
                      </span>
                    }
                  >
                    {dataFetching ? (
                      <MemberSkeleton />
                    ) : isAPIFailed ? (
                      <Container className="px-0">
                        {isNotFound ? (
                          <CustomClientError
                            ErrorHeading="No Coverages found!"
                            ErrorMessage="No coverage history data found for current member "
                            NoDataFound={true}
                          />
                        ) : (
                          <CustomClientError
                            ErrorHeading="Something went wrong with request!"
                            ErrorMessage="Server request failed. Please contact support team."
                          />
                        )}
                      </Container>
                    ) : !showPermissionError ? (
                      selectedTab === 'coverages' &&
                      coverageData && (
                        <Coverage
                          memberType={memberType}
                          userOID={currentUser}
                          employeeInfo={memberInfo}
                          dependentsInfo={dependentList}
                          memberSummary={memberSummary}
                          activeCoverage={activeCoverage}
                          selectedUser={selectedUser}
                          coverageFor={coverageFor}
                          coverageProducts={coverageProducts}
                          planDetails={planDetails}
                          coverageData={coverageData}
                          dataFetching={dataFetching}
                          isAPIFailed={isAPIFailed}
                          isNotFound={isNotFound}
                          isFamilySelected={isFamilySelected}
                          defaultData={defaultData}
                        />
                      )
                    ) : (
                      <CustomClientError
                        ErrorHeading="No Coverages found!"
                        ErrorMessage="No coverage history data found for current member"
                        NoDataFound={true}
                      />
                    )}
                    <EmailSVG />
                  </Tab>
                )}
              {MasterPermissions.CheckPermission('View Claims') && (
                <Tab
                  eventKey="claims"
                  title={
                    <span>
                      <ClaimsSVG
                        className="svg-icons"
                        parentClassName="svg-class"
                      />
                      Claims
                    </span>
                  }
                >
                  {selectedTab === 'claims' && (
                    <Claims
                      memberType={memberType}
                      userOID={currentUser}
                      preserveData={{ ...location.state }}
                      selectedUser={selectedUser}
                      coverageFor={coverageFor}
                      coverageProducts={coverageProducts}
                      planDetails={planDetails}
                      coverageData={coverageData}
                      dataFetching={dataFetching}
                      isAPIFailed={isAPIFailed}
                      isNotFound={isNotFound}
                      isFamilySelected={isFamilySelected}
                      defaultData={defaultData}
                      selectedUserFirstName={
                        location.state?.selectedUserFirstName
                      }
                      selectedUserLastName={
                        location.state?.selectedUserLastName
                      }
                      selectedUserEmail={location.state?.selectedUserEmail}
                    />
                  )}
                  <EmailSVG />
                </Tab>
              )}
              {isAccountsVisible == false &&
                memberType != 'Dependent' &&
                !isFamilySelected &&
                userTypeCheck != 'Provider' &&
                MasterPermissions.CheckPermission(
                  'View Spending Account Details',
                ) && (
                  <Tab
                    eventKey="acsummary"
                    title={
                      <span>
                        <AccountsSVG
                          className="svg-icons"
                          parentClassName="svg-class"
                        />
                        Account Summary
                      </span>
                    }
                  >
                    {selectedTab === 'acsummary' && (
                      <Accounts
                        memberType={memberType}
                        userOID={currentUser}
                        membersCovered={coverageFor}
                        planDetails={planDetails}
                        coverageData={coverageData}
                        preserveData={{ ...location.state }}
                        isFamilySelected={isFamilySelected}
                        isAPIFailed={isAPIFailed}
                        isNotFound={isNotFound}
                      />
                    )}
                  </Tab>
                )}
              {userTypeCheck != 'Provider' &&
                MasterPermissions.CheckPermission('View ID Cards') && (
                  <Tab
                    eventKey="idcards"
                    title={
                      <span>
                        <IDCardSVG
                          className="svg-icons"
                          parentClassName="svg-class"
                        />
                        ID Cards
                      </span>
                    }
                  >
                    {dataFetching ? (
                      <MyIDCardSkeleton />
                    ) : isAPIFailed ? (
                      <Container className="px-0">
                        {isNotFound ? (
                          <CustomClientError
                            ErrorHeading="No ID Card found!"
                            ErrorMessage="The selected Member does not have ID Card. "
                            NoDataFound={true}
                          />
                        ) : (
                          <CustomClientError
                            ErrorHeading="Something went wrong with request!"
                            ErrorMessage="Please try again."
                          />
                        )}
                      </Container>
                    ) : (
                      selectedTab === 'idcards' &&
                      coverageProducts && (
                        <MyIDCards
                          memberType={memberType}
                          userOID={currentUser}
                          coverageProducts={coverageProducts}
                          isFamilySelected={isFamilySelected}
                          selectedUserFirstName={
                            location.state?.selectedUserFirstName
                          }
                          selectedUserLastName={
                            location.state?.selectedUserLastName
                          }
                          selectedUserEmail={location.state?.selectedUserEmail}
                        />
                      )
                    )}
                  </Tab>
                )}
              {isDocumentVisible &&
                MasterPermissions.CheckPermission('View Document') && (
                  <Tab
                    eventKey="documents"
                    title={
                      <span>
                        <DocumentsSVG
                          className="svg-icons"
                          parentClassName="svg-class"
                        />
                        Documents
                      </span>
                    }
                  >
                    {selectedTab === 'documents' && (
                      <div>
                        <ViewAllDocuments
                          preserveData={{ ...location.state }}
                        />
                        {/*<ViewAllDocuments dataFetching={dataFetching} /> */}
                      </div>
                    )}
                  </Tab>
                )}
              {((userTypeCheck != 'Provider' &&
                MasterPermissions.CheckPermission(
                  'View Self Profile Information',
                )) ||
                MasterPermissions.CheckPermission(
                  ' View Dependent Profile Information',
                ) ||
                MasterPermissions.CheckPermission(
                  'View HIPAA Patient Rights Information',
                )) &&
                ['Insurer', 'Client', 'Provider', 'Broker'].includes(
                  userData?.UserType,
                ) && (
                  <Tab
                    eventKey="profile"
                    title={
                      <span>
                        <ProfileSVG
                          className="svg-icons"
                          parentClassName="svg-class"
                        />
                        Profile
                      </span>
                    }
                  >
                    {selectedTab === 'profile' && (
                      <div>
                        <Profile
                          memberType={memberType}
                          coverageFor={coverageFor}
                        />
                      </div>
                    )}
                  </Tab>
                )}

              {/*Accumulator tab start */}
              {userTypeCheck != 'Provider' &&
                isBenefitAccumsVisible &&
                memberType != 'Dependent' &&
                !isFamilySelected &&
                MasterPermissions.CheckPermission('View Accumulators') && (
                  <Tab
                    eventKey="accumulators"
                    title={
                      <span>
                        <AccumulatorSVG
                          className="svg-icons"
                          parentClassName="svg-class"
                        />
                        Accumulators
                      </span>
                    }
                  >
                    {/*{selectedTab === 'accumulators' && coverageData && ( */}
                    {selectedTab === 'accumulators' && (
                      <Accumulators
                        memberType={memberType}
                        userOID={currentUser}
                        employeeInfo={memberInfo}
                        dependentsInfo={dependentList}
                        memberSummary={memberSummary}
                        activeCoverage={activeCoverage}
                        selectedUser={selectedUser}
                        coverageFor={coverageFor}
                        coverageProducts={coverageProducts}
                        planDetails={planDetails}
                        coverageData={coverageData}
                        dataFetching={dataFetching}
                        isAPIFailed={isAPIFailed}
                        isNotFound={isNotFound}
                        isFamilySelected={isFamilySelected}
                        displayErrorMsg={displayErrorMsg}
                      />
                    )}
                  </Tab>
                )}
              {/*Accumulator tab end */}
            </Tabs>
          </Col>
        </Row>
      </div>
      {/*<div className="toastify">
        <ToastContainer
          position="top-center"
          autoClose={5000}
          hideProgressBar={false}
          newestOnTop={false}
          closeOnClick
          rtl={false}
          pauseOnFocusLoss
          draggable
          pauseOnHover
          className="toastcontainer"
        />
      </div> */}
    </div>
  );
};
export default ViewMember;
